module.exports = __webpack_public_path__ + "static/media/youtube.4aa21897.svg";